import React from 'react';
import { FormikInput } from 'components/UiKit/FormikFields';

const Range = () => {
  return (
    <FormikInput
      placeholder="Enter range"
      name="range"
      id="range"
      label="Range"
    />
  );
};

export default Range;
